const guiColors = {
    'motion-primary': '#ff7f2a', // bright orange
    'motion-primary-transparent': '#ff7f2ae6', // semi-transparent orange
    'motion-tertiary': '#e65c00', // darker orange

    'looks-secondary': '#ff7f2a', // bright orange
    'looks-transparent': '#ff7f2a59', // more transparent orange
    'looks-light-transparent': '#ff7f2a26', // very transparent orange
    'looks-secondary-dark': 'hsla(25, 100%, 45%, 1)', // dark orange

    'extensions-primary': 'hsla(30, 100%, 65%, 1)', // light orange
    'extensions-tertiary': 'hsla(30, 90%, 45%, 1)', // medium orange
    'extensions-transparent': 'hsla(30, 90%, 65%, 0.35)', // semi-transparent orange
    'extensions-light': 'hsla(30, 100%, 85%, 1)', // very light orange

    'drop-highlight': '#ffad66' // light orange
};

const blockColors = {
    checkboxActiveBackground: '#ff7f2a', // bright orange
    checkboxActiveBorder: '#e65c00' // darker orange
};

export {
    guiColors,
    blockColors
};
